<template>
  <Transition
    appear
    enter-active-class="transition-opacity delay-100 duration-100 ease-out"
    enter-from-class="opacity-0"
    leave-active-class="transition-opacity duration-100 ease-out"
    leave-to-class="opacity-0"
  >
    <div class="flex h-full flex-col justify-between">
      <RevList
        class="divide-y-0"
        data-qa="store-nav-list-items"
        :has-external-borders="false"
      >
        <RevListItemInteractive
          v-if="current"
          class="hover:bg-surface-default-low"
          :to="current.link"
          @click="onMenuItemClick && onMenuItemClick({ item: current })"
        >
          <template #label>
            <div class="flex items-center">
              <span class="body-1-bold grow">
                {{ i18n(translations.showAllDepartments) }}
              </span>
            </div>
          </template>
        </RevListItemInteractive>

        <RevListItemInteractive
          v-for="item in menuItems"
          :key="item.title"
          class="hover:bg-surface-default-low"
          data-test="store-nav-list-item-mobile"
          :to="hasChildren(item) ? undefined : item.link"
          @click="emit('menuItemClick', { item })"
        >
          <template #prefix v-if="item.image">
            <RevIllustration
              alt=""
              class="h-24 w-24"
              :height="24"
              :src="item.image"
              :width="24"
            />
          </template>
          <template #label>
            <div class="flex items-center">
              <span
                class="body-1-bold grow"
                :style="{ color: item?.style?.text_color }"
              >
                {{ item.title }}
              </span>

              <IconChevronRight v-if="hasChildren(item)" />
            </div>
          </template>
        </RevListItemInteractive>
      </RevList>

      <div class="flex grow flex-col justify-end pb-8">
        <RevLink
          v-for="link in links"
          :key="link.name"
          class="body-2-link flex items-center py-8 pl-20"
          :to="link.href"
          :underlined="false"
          @click="emit('linkClick', { name: link.name })"
        >
          {{ link.label }}
        </RevLink>
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
import type { Locale, navigationAPI } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevList } from '@ds/components/List'
import { RevListItemInteractive } from '@ds/components/ListItemInteractive'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './BurgerMenu.translations'

defineProps<{
  menuItems: navigationAPI.MenuItem[]
  links?: {
    name: string
    href: { name: string; params: { locale: Locale } }
    label: string
  }[]
  current?: navigationAPI.MenuItem
}>()

const i18n = useI18n()

const emit = defineEmits<{
  menuItemClick: [{ item: navigationAPI.MenuItem }]
  linkClick: [{ name: string }]
}>()

function hasChildren(item: navigationAPI.MenuItem) {
  return item.children?.length > 0
}
</script>
